/**
 * This file handles the connection to the API of usermangement-service
 */

import axios from "axios";
import { keycloak as Keycloak}  from "../main.js";

const BASE_URL = config.VUE_APP_USERMANAGEMENT_SERVICE_URL ?? process.env.VUE_APP_USERMANAGEMENT_SERVICE_URL;
const BASE_URL_V2 = config.VUE_APP_USERMANAGEMENT_SERVICE_URL_V2 ?? process.env.VUE_APP_USERMANAGEMENT_SERVICE_URL_V2;

const API = axios.create({
    baseURL: BASE_URL,
    timeout: 30000,
    crossDomain: true
});


const API_V2 = axios.create({
    baseURL: BASE_URL_V2,
    timeout: 30000,
    crossDomain: true
});

API.interceptors.request.use(
    request => {
        request.headers.Authorization = `Bearer ${Keycloak.token}`;
        return request;
    }
);


API.interceptors.response.use(
    response => response,
    error => {
        if (error.response) {
            const errorStatus = error.response.status;
            if (errorStatus == 401) {
               localStorage.clear();
               Keycloak.logout();
            }
        }

        let errorResponse = {};

        errorResponse.message = (error?.response?.data?.message) ? error.response.data.message : "Unkown Message!";
        errorResponse.type = (error?.response?.data?.Type) ? error.response.data.Type : "UnkownType";
        errorResponse.statusCode = (error?.response?.status) ? error.response.status : "500";

        return Promise.reject(errorResponse);
    }
);

API_V2.interceptors.request.use(
    request => {
        request.headers.Authorization = `Bearer ${Keycloak.token}`;
        return request;
    }
);

API_V2.interceptors.response.use(
    response => response,
    error => {
        if (error.response) {
            const errorStatus = error.response.status;
            if (errorStatus == 401) {
               localStorage.clear();
               Keycloak.logout();
            }
        }
        
        let errorResponse = {};

        errorResponse.message = (error?.response?.data?.message) ? error.response.data.message : "Unkown Message!";
        errorResponse.type = (error?.response?.data?.Type) ? error.response.data.Type : "UnkownType";
        errorResponse.statusCode = (error?.response?.status) ? error.response.status : "500";

        return Promise.reject(errorResponse);
    }
);

export { BASE_URL, API_V2, BASE_URL_V2, API};